import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import AdminLogo from "@/components/admin/AdminLogo";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Login berhasil");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login gagal");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center p-6">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: "url(/login-bg.png)" }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-[#E82020]/45" aria-hidden />
      <form
        onSubmit={submit}
        data-testid="login-form"
        autoComplete="off"
        className="relative w-full max-w-md bg-white/95 backdrop-blur-sm rounded-3xl p-10 shadow-2xl"
      >
        <AdminLogo className="h-14" />
        <h1 className="mt-6 text-3xl font-display font-bold text-zinc-900">Admin Login</h1>
        <p className="mt-2 text-sm text-zinc-500">Masuk untuk mengelola konten website.</p>
        <div className="mt-8 space-y-4">
          <div>
            <label className="block text-sm font-semibold text-zinc-800 mb-2">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              autoComplete="off"
              data-testid="login-email"
              className="w-full px-4 py-3 rounded-xl border border-zinc-200 focus:border-maroon-700 focus:ring-2 focus:ring-maroon-100 outline-none"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-zinc-800 mb-2">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              autoComplete="current-password"
              data-testid="login-password"
              className="w-full px-4 py-3 rounded-xl border border-zinc-200 focus:border-maroon-700 focus:ring-2 focus:ring-maroon-100 outline-none"
            />
          </div>
        </div>
        <button type="submit" disabled={loading} data-testid="login-submit"
          className="mt-8 w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-maroon-800 text-white font-semibold hover:bg-maroon-900 disabled:opacity-60 transition">
          {loading ? "Memproses..." : (<><LogIn size={16} /> Masuk</>)}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
